'use strict';

angular.module('shiftTraderApp')
  .directive('saNoteAttachFiles', ['LibraryStore', 'ServerUrls', 'flash', function(LibraryStore, ServerUrls, flash) {
    return {
      restrict: 'A',
      scope: {
        label: "@?label",
        minimal: '@?minimal'
      },
      require: '^saNoteCreate',
      template: '<div class="notes-attach-files-button"><i class="icon-good-paperclip"></i></div>',
      link: function(scope, element, attr, parentCtrl) {

        var button = $(element).find('div');
        if (scope.label) {
          $(button).append('<span>&ensp;' + scope.label + '</span>');
        }

        if (scope.minimal === 'true') {
          $(button).addClass('btn-only-icon');
        } else {
          $(button).addClass('btn');
        }

        function init() {
          LibraryStore.load('filestack')
            .then(function() {
              scope.state.filestackLoaded = true;

              if (scope.state.filepickerPending) {
                window.filepicker();
              }
              filepicker.setKey(ServerUrls['current']['filestackKey']);
            }, function() {
              // TODO -- Wh
            })
        }

        scope.state = {
          filestackLoaded: false,
          filepickerPending: false
        };

        $(element).find('.notes-attach-files-button').on('click touchstart', function() {
          if (!window.filepicker) {
            scope.state.filepickerPending = true;
          } else {
            parentCtrl.beginMediaUpload();
            filepicker.pickAndStore({
              multiple: true,
              maxFiles: '5',
              maxSize: '1024*1024*1024', // 1GB
              services: ['COMPUTER', 'GOOGLE_DRIVE', 'DROPBOX', 'BOX', 'WEBCAM', 'URL'], // removed 'VIDEO' for now
              types: ['image/png',
                      'image/jpeg',
                      'image/gif',
                      // 'video/quicktime',
                      // 'video/mpeg',
                      // 'video/mp4',
                      'application/pdf',
                      'application/msword',
                      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                      'application/mspowerpoint',
                      'application/vnd.ms-powerpoint',
                      'application/vnd.openxmlformats-officedocument.presentationml.presentation',
                      'application/vnd.ms-excel',
                      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    ],
              webcam: { videoLen: '1800', videoRes: '1280x720'}
            }, {
              location: 'S3'
            }, function(blobs) {
              scope.$apply(function() {
                // Get external_id from url
                _.each(blobs, function(b) {
                  b.external_id = (b.url.match(/\/([^\/]+)$/) || ['', null])[1]
                });

                parentCtrl.setMediaData('filestack', blobs);
                parentCtrl.endMediaUpload();
              });
            }, function(err) {
              // if err.code is 101 we're assuming that it just means that there was no upload attempted
              if (!err.code === 101) {
                flash.error = 'We are sorry, we were unable to upload your media.';
              }
              scope.$apply(function() {
                parentCtrl.endMediaUpload();
              });
            }, function(progress) {
              // SATODO: Progress case????
            });

          }
        });

        init();
      }
    }
  }]);
